import * as Api from 'utils/api'
import { toggleLoading } from 'actions/app'
import { createAction } from 'redux-actions'
import { browserHistory } from 'react-router'
import { call, put, all } from 'redux-saga/effects'
import { takeLatest, takeEvery } from 'redux-saga'
const { alert } = window

export default function* rootSaga () {
  yield [
    loginSaga(),
    getUserSaga(),
    recognizeSaga(),
    searchByIdSaga(),
    searchByImageSaga(),
    toValidateSaga(),
    getCategoriesSaga(),
    changeCategorySaga(),
    getJobsSaga(),
    getAnnotationsSaga(),
    saveAllAndNextJobSaga(),
    searchProductSagas(),
    searchProductsSagas(),
    skipAndNextJobSagas(),
    resetAndNextJobSagas(),
    selectAlternativeImageSagas(),
    getLookSagas(),
    getLookProductsSagas(),
    getAnnotationFromStyleAdvisorSagas(),
    getTwinnedLooksSagas(),
    getTextSearchSagas(),
    getFinalAnnotationLookProductsSagas()

  ]
}

function* loginSaga () { yield * takeLatest('USER_LOGIN_REQUESTED', login) }
function* getUserSaga () { yield * takeEvery('GET_USER_REQUESTED', getUser) }
function* recognizeSaga () { yield * takeLatest('RECOGNIZE_PRODUCTS_REQUESTED', recognize) }
function* searchByIdSaga () { yield * takeLatest('GET_SIMILARS_REQUESTED', searchById) }
function* searchByImageSaga () { yield * takeLatest('SEARCH_BY_IMAGE_REQUESTED', searchByImage) }
function* toValidateSaga () { yield * takeLatest('GET_IMAGE_TO_VALIDATE_REQUESTED', toValidate) }
function* getCategoriesSaga () { yield * takeLatest('GET_CATEGORIES_REQUESTED', getCategories) }
function* changeCategorySaga () { yield * takeLatest(' CHANGE_CATEGORY_REQUESTED', changeCategory) }
function* getJobsSaga () { yield * takeLatest('GET_JOBS_REQUESTED', getJobs) }
function* getAnnotationsSaga () { yield * takeLatest('GET_ANNOTATIONS_REQUESTED', getAnnotations) }
function* saveAllAndNextJobSaga () { yield * takeLatest('SAVE_ALL_REQUESTED', saveAllAndNextJob) }
function* searchProductSagas () { yield * takeLatest('SEARCH_PRODUCT_REQUESTED', searchProduct) }
function* searchProductsSagas () { yield * takeLatest('SEARCH_PRODUCTS_REQUESTED', searchProducts) }
function* skipAndNextJobSagas () { yield * takeLatest('SKIP_AND_FINISH_REQUESTED', skipAndNextJob) }
function* resetAndNextJobSagas () { yield * takeLatest('RESET_AND_FINISH_REQUESTED', resetAndNextJob) }
function* selectAlternativeImageSagas () { yield * takeLatest('SELECT_ALTERNATIVE_IMAGE_REQUESTED', selectAlternativeImage) }
function* getLookSagas () { yield * takeLatest('GET_LOOK_REQUESTED', getLook) }
function* getLookProductsSagas () { yield * takeLatest('GET_LOOK_PRODUCTS_REQUESTED', getLookProducts) }
function* getAnnotationFromStyleAdvisorSagas () { yield * takeLatest('GET_ANNOTATION_FROM_STYLE_ADVISOR_REQUESTED', getAnnotationFromStyleAdvisor) }
function* getTwinnedLooksSagas () { yield * takeLatest('GET_TWINNED_LOOKS_REQUESTED', getTwinnedLooks) }
function* getFinalAnnotationLookProductsSagas () { yield * takeLatest('GET_FINAL_ANNOTATION_LOOK_PRODUCTS_REQUESTED', getFinalAnnotationLookProducts) }

function* getTextSearchSagas () { yield * takeLatest('GET_TEXT_SEARCH_REQUESTED', getTextSearch) }

function* searchProduct (action) {
  try {
    const res = yield call(Api.searchProduct, action.payload.apikey, action.payload.token,
      { 'uid': action.payload.data.uid })
    yield put(createAction('SEARCH_PRODUCT_RECEIVED')(res))
  } catch (e) {
    alert('SEARCH_PRODUCT_FAILED: ' + e + ' uid ' + action.payload.data.uid)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('SEARCH_PRODUCT_FAILED')(e))
  }
}

function* searchProducts (action) {
  try {
    const res = yield call(Api.getProducts, action.payload.apikey, action.payload.token, action.payload.data)
    yield put(createAction('SEARCH_PRODUCTS_RECEIVED')(res))
  } catch (e) {
    alert('SEARCH_PRODUCTS_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('SEARCH_PRODUCTS_FAILED')(e))
  }
}

function* getJobs (action) {
  try {
    yield put(toggleLoading(true))
    const res = yield call(Api.getJobs, action.payload.token, action.payload.data)
    yield put(createAction('GET_JOBS_COMPLETED')(res))
    yield put(toggleLoading(false))
  } catch (e) {
    alert('GET_JOBS_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('GET_JOBS_FAILED')(e))
  }
}

function* selectAlternativeImage (action) {
  try {
    yield put(toggleLoading(true))
    const data = {
      image: action.payload.data.image.url
    }
    yield put(createAction('SELECT_ALTERNATIVE_IMAGE_COMPLETED')(action.payload.data.image))
    // we call detect after setting the main image
    let res2 = yield call(Api.detect, action.payload.token, data)
    // TMPFIX we have 0 detections to mock one to perform any search and let this shit work.
    if (!(res2 && res2.results && res2.results.detections && res2.results.detections.length)) {
      res2 = {
        results: {
          detections: [
            {
              bbox: {
                x1: 0,
                y1: 0,
                x2: 1,
                y2: 1
              }
            }
          ]
        }
      }
    }
    yield put(createAction('RECOGNIZE_PRODUCTS_COMPLETED')(res2.results))
    // Once we have the new detections we have to call search by image to get the results
    const dataSearchByImage = {
      bboxes: res2.results.detections && res2.results.detections.length > 0 ? [res2.results.detections[0].bbox] : null,
      image: action.payload.data.image.url,
      gender: JSON.parse(action.payload.data.image.customData).gender,
      maxNumResults: 50,
      maxNumCategories: 20
    }
    const res = yield call(Api.searchByImageWithApiKey, action.payload.apikey, dataSearchByImage)
    yield put(toggleLoading(false))
    yield put(createAction('SEARCH_BY_IMAGE_COMPLETED')({
      results: res.results,
      attributes: res.attributes,
      data: dataSearchByImage
    }))
  } catch (e) {
    alert('SELECT_ALTENATIVE_IMAGES_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('SELECT_ALTENATIVE_IMAGES_FAILED')(e))
  }
}

function* getCategories (action) {
  try {
    yield put(toggleLoading(true))
    const res = yield call(Api.getCategories, action.payload.apikey, action.payload.token)
    yield put(createAction('GET_CATEGORIES_COMPLETED')(res.categories))
    yield put(toggleLoading(false))
  } catch (e) {
    alert('GET_CATEGORIES_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('GET_CATEGORIES_FAILED')(e))
  }
}

// PATCH=https://wideeyes.atlassian.net/wiki/spaces/DEV/pages/616759331/WID-823+Imposible+to+change+category+in+annotation+platform
function* changeCategory (action) {
  try {
    yield put(toggleLoading(true))
    const res = yield call(Api.changeCategory, action.payload.apikey, action.payload.token,
      {
        uid: action.payload.uid
      })
    yield put(createAction('CHANGE_CATEGORY_COMPLETED')(res))
    yield put(toggleLoading(false))
  } catch (e) {
    alert('CHANGE_CATEGORY_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('CHANGE_CATEGORY_FAILED')(e))
  }
}

/**
 * Method to try to extract recognize using images on data.
 * @param action
 * @param imageInfo
 * @param lookInfo
 * @returns {Generator<*, void, *>}
 */
function* toValidateRecognize (action, imageInfo, lookInfo) {
  try {
    return yield call(Api.recognize, action.payload.apikey, { 'image': imageInfo.url, 'gender': lookInfo.gender })
  } catch (e) {
    return { 'results': [] } // annotator can continue without this data manually.
  }
}

/**
 * Gets next image to be validated.
 * @param action
 * @returns {Generator<(CallEffect|Generator<*, void, *>)[]|CallEffect|PutEffect<*>, void, *>}
 */
function* toValidate (action) {
  try {
    yield put(toggleLoading(true))
    const res = yield call(Api.toValidate, action.payload.token, action.payload.data)
    const lookInfo = JSON.parse(res.customData)
    // TMPFIX: Another shit hack to avoid images without url we got one from alternatives.
    let imageUrl = res.url
    if (!imageUrl && lookInfo.alternativeImages) {
      imageUrl = lookInfo.alternativeImages[0]
    }
    res.url = imageUrl
    const [res2, recognizeResult] = yield [
      call(Api.getAnnotations, action.payload.token, {
        image: res,
        jobId: action.payload.data.jobId
      }),
      toValidateRecognize(action, res, lookInfo)
    ]
    res2.annotations[0].data = JSON.stringify(recognizeResult)
    yield put(createAction('GET_IMAGE_TO_VALIDATE_COMPLETED')(res))
    yield put(createAction('GET_ANNOTATIONS_COMPLETED')(res2))
    yield put(toggleLoading(false))
  } catch (e) {
    alert('There aren\'t looks to annotate for this user')
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('GET_IMAGE_TO_VALIDATE_FAILED')(e))
  }
}

function* getAnnotations (action) {
  try {
    yield put(toggleLoading(true))
    const res = yield call(Api.recognize, action.payload.token, action.payload.data)
    yield put(createAction('GET_ANNOTATIONS_COMPLETED')(res))
    yield put(toggleLoading(false))
  } catch (e) {
    alert('GET_ANNOTATIONS_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('GET_ANNOTATIONS_FAILED')(e))
  }
}

function* recognize (action) {
  try {
    yield put(toggleLoading(true))
    const res = yield call(Api.recognize, action.payload.token, action.payload.data)
    yield put(createAction('RECOGNIZE_PRODUCTS_COMPLETED')(res))
    yield put(toggleLoading(false))
    forwardTo('/')
  } catch (e) {
    alert('RECOGNIZE_PRODUCTS_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('RECOGNIZE_PRODUCTS_FAILED')(e))
  }
}

function* skipAndNextJob (action) {
  try {
    yield put(toggleLoading(true))

    yield call(Api.deleteImage, action.payload.token,
      {
        imageId: action.payload.data.uid,
        jobId: action.payload.data.jobId
      }
    )
    yield put(toggleLoading(false))

    location.reload()
  } catch (e) {
    alert('SKIP_AND_FINISH_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('SKIP_AND_FINISH_FAILED')(e))
  }
}

function* resetAndNextJob (action) {
  let simplifiedDetections = action.payload.data.annotationData.detections.map((x) => {
    delete x.attributes
    delete x.results
    return x
  })

  try {
    yield put(toggleLoading(true))

    const res = yield call(Api.saveDetection, action.payload.token,
      {
        jobId: action.payload.data.annotationData.jobId,
        annotationId: action.payload.data.annotationData.annotationId,
        imageId: action.payload.data.imageData.id
      },
      {
        data: JSON.stringify({
          errors: [],
          results: simplifiedDetections
        })
      }
    )

    const res2 = yield call(Api.toLastJob, action.payload.token,
      {
        jobId: parseInt(action.payload.data.imageData.jobId),
        imageId: parseInt(action.payload.data.imageData.id)
      }
    )
    yield put(toggleLoading(false))
    yield put(createAction('RESET_AND_FINISH_COMPLETE')())
    if (res && res2) {
      setTimeout(() => {
        location.reload()
      }, 3000)
    }
  } catch (e) {
    alert('RESET_AND_FINISH_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('RESET_AND_FINISH_FAILED')(e))
  }
}

function* saveAllAndNextJob (action) {
  // remove data we don't want to send
  let simplifiedDetections = action.payload.data.annotationData.detections.map((x) => {
    delete x.attributes
    delete x.internal_ref
    delete x.results
    return x
  })

  try {
    yield put(toggleLoading(true))

    const res = yield call(Api.saveDetection, action.payload.token,
      {
        jobId: action.payload.data.annotationData.jobId,
        annotationId: action.payload.data.annotationData.annotationId,
        imageId: action.payload.data.imageData.id
      },
      {
        data: JSON.stringify({
          errors: [],
          results: simplifiedDetections
        })
      }
    )

    const res2 = yield call(Api.updateImage, action.payload.token,
      {
        jobId: action.payload.data.imageData.jobId,
        imageId: action.payload.data.imageData.id
      },
      action.payload.data.imageData
    )

    const res3 = yield call(Api.toNextJob, action.payload.token,
      {
        jobId: parseInt(action.payload.data.imageData.jobId),
        imageId: parseInt(action.payload.data.imageData.id)
      }
    )
    yield put(createAction('SAVE_ALL_COMPLETED')({}))
    if (res && res2 && res3) {
      setTimeout(function () {
        location.reload()
      }, 3000)
    } else {
      alert('Error occured sending information. Please, try again. ')
    }
  } catch (e) {
    alert('SAVE_ALL_COMPLETED_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('SAVE_ALL_COMPLETED_FAILED')(e))
  }
}

function* searchById (action) {
  try {
    const res = yield call(Api.searchById, action.payload.apikey, action.payload.data)
    yield put(createAction('GET_SIMILARS_COMPLETED')({
      results: res.results[0].products
    }))
  } catch (e) {
    alert('GET_SIMILARS_FAILED: ' + e)
  }
}

function* searchByImage (action) {
  try {
    yield put(toggleLoading(true))
    const res = yield call(Api.searchByImageWithApiKey, action.payload.apikey, action.payload.data)
    yield put(toggleLoading(false))
    yield put(createAction('SEARCH_BY_IMAGE_COMPLETED')({
      results: res.results,
      attributes: res.attributes,
      data: action.payload.data
    }))
  } catch (e) {
    alert('SEARCH_BY_IMAGE_FAILED: ' + e)
    if (e.status === 401) yield put(createAction('LOGOUT')())
    yield put(createAction('SEARCH_BY_IMAGE_FAILED')(e))
  }
}

function* getLook (action) {
  try {
    const res = yield call(Api.getLook, action.payload.apikey, action.payload.token, action.payload.data)
    yield put(createAction('GET_LOOK_COMPLETED')({
      results: res.results
    }))
  } catch (e) {
    yield put(createAction('GET_LOOK_FAILED')(e))
  }
}

function* getLookProducts (action) {
  try {
    const filteredUids = action.payload.data.uids.filter(uid => uid != null);
    const calls = filteredUids.map(uid => call(getLookProductsCall, action.payload.apikey, action.payload.token, uid))
    const responses = yield all(calls)
    const looksNoProducts = action.payload.data.lookNoProducts || []

    yield put(createAction('GET_LOOK_PRODUCTS_COMPLETED')({
      results: responses.map(res => res.results[0]),
      lookNoProducts: looksNoProducts
    }))
  } catch (e) {
    yield put(createAction('GET_LOOK_PRODUCTS_FAILED')(e))
  }
}

function* getAnnotationFromStyleAdvisor (action) {
  try {
    const { apikey, data, token } = action.payload
    const res = yield call(Api.getAnnotationFromStyleAdvisor, apikey, data)
    const payload = { ...res, token }
    yield put(createAction('GET_ANNOTATION_FROM_STYLE_ADVISOR_COMPLETED')(payload))
  } catch (e) {
    yield put(createAction('GET_ANNOTATION_FROM_STYLE_ADVISOR_FAILED')(e))
  }
}

function* getTwinnedLooks (action) {
  try {
    const { apikey, data, token } = action.payload
    const responseTwinnedLooks = yield call(Api.getTwinnedLooks, apikey, data)
    const twinnedLooks = responseTwinnedLooks.result.results
    let calls = []
    twinnedLooks.map((look) => {
      calls.push(look.products.map((product) => {
        return call(getLookProductsCall, apikey, token, product.match)
      }))
    })
    const resultCalls = yield all(calls)

    const allProductLooks = {}
    resultCalls.forEach(responseCallForLook => {
      responseCallForLook.forEach(({ errors, results }) => {
        const prod = results[0]
        allProductLooks[prod.uid] = prod
      })
    })

    /**
     * We want to rebuild every twinned look object
     * to have all the matches (products) details from the api
     */
    const updatedLooks = twinnedLooks.map(look => {
      const updatedProducts = look.products.map(product => {
        return { ...allProductLooks[product.match] }
      })
      return { ...look, products: updatedProducts }
    })

    const payload = { result: updatedLooks, token }
    yield put(createAction('GET_TWINNED_LOOKS_COMPLETED')(payload))
  } catch (e) {
    yield put(createAction('GET_TWINNED_LOOKS_FAILED')(e))
  }
}

function* getTextSearch (action) {
  try {
    const { apikey, data } = action.payload
    const res = yield call(Api.getTextSearchProducts, apikey, data)
    yield put(createAction('GET_TEXT_SEARCH_COMPLETED')({
      results: res.results[0].products
    }))
  } catch (e) {
    yield put(createAction('GET_TEXT_SEARCH_FAILED')(e))
  }
}

function* getFinalAnnotationLookProducts (action) {
  try {
    const { apikey, data, token } = action.payload
    console.log('getFinalAnnotationLookProducts data: ', data)

    let calls = []

    calls.push(data.map((detection) => {
      if ('perfectMatch' in detection) {
        return call(getLookProductsCall, apikey, token, detection.perfectMatch)
      } else {
        return null
      }
    }))
    const resultCalls = yield all(calls)

    const allProductLooks = []

    resultCalls.forEach(responseCallForLook => {
      responseCallForLook.forEach((response) => {
        if (response) {
          const { results } = response
          if (results && results.length > 0) {
            if (results[0]) {
              allProductLooks.push(results[0])
            }
          }
        }
      })
    })

    if (allProductLooks.length === 0) {
      yield put(createAction('GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_FAILED')('No products annoted.'))
    } else {
      const payload = { result: allProductLooks, token }
      yield put(createAction('GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_COMPLETED')(payload))
    }
  } catch (e) {
    yield put(createAction('GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_FAILED')(e))
  }
}

function* getLookProductsCall (apikey, token, uid) {
  try {
    return yield call(Api.getLookProducts, apikey, token, uid)
  } catch (e) {
    return yield call(Api.getLookProductsInactive, apikey, token, uid)
  }
}

function* login (action) {
  try {
    const { access_token } = yield call(Api.login, action.payload)

    yield put(toggleLoading(true))
    const res = yield call(Api.getUser, access_token)

    yield put(toggleLoading(false))

    yield put(createAction('USER_LOGGED_IN_COMPLETED')({ ...res, token: access_token }))

    forwardTo('/')
  } catch (e) {
    alert('USER_LOGGED_IN_FAILED: ' + e)
    yield put(createAction('USER_LOGGED_IN_FAILED')(e))
  }
}

function* getUser (action) {
  try {
    const res = yield call(Api.getUser, action.payload)
    const payload = { ...res, token: action.payload }
    yield put(createAction('GET_USER_COMPLETED')(payload))
  } catch (e) {
    alert('GET_USER_FAILED: ' + e)
    yield put(createAction('GET_USER_FAILED')(e))
  }
}

const forwardTo = loc => browserHistory.push(loc)



// WEBPACK FOOTER //
// ./src/sagas/index.js